import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function copyText(value: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    const area = document.createElement('textarea');
    area.value = value;
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.append(area);
    area.select();
    const copied = document.execCommand('copy');
    area.remove();
    return copied;
  }
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function relativeTime(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '';
  const seconds = Math.round((now - Date.parse(iso)) / 1000);
  const abs = Math.abs(seconds);
  const format = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  if (abs < 45) return 'just now';
  if (abs < 3600) return format.format(-Math.round(seconds / 60), 'minute');
  if (abs < 86_400) return format.format(-Math.round(seconds / 3600), 'hour');
  if (abs < 86_400 * 30) return format.format(-Math.round(seconds / 86_400), 'day');
  if (abs < 86_400 * 365) return format.format(-Math.round(seconds / (86_400 * 30)), 'month');
  return format.format(-Math.round(seconds / (86_400 * 365)), 'year');
}

/** Stable, readable key for React lists built from editable rows. */
let keyCounter = 0;
export function localKey(prefix = 'k'): string {
  keyCounter += 1;
  return `${prefix}${Date.now().toString(36)}${keyCounter.toString(36)}`;
}
